module.exports = __webpack_public_path__ + "static/media/ICSRounded.11accb80.png";